import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Translation } from 'react-i18next';

import './CommonUnlockProBtn.css';

const CommonUnlockProBtn = ({ me, className }) => {
  if (me && me.subscription && me.subscription.billing_plan && me.subscription.billing_plan.title === 'Pro') {
    return null;
  }

  return (
    <Translation>
      {(t) => (
        <Link
          className={`common-unlock-pro-btn__component ${className}`}
          to="/billing"
        >
          <div className="icon unlock-pro" />
          <div className="text">{t("Unlock PRO")}</div>
        </Link>
      )}
    </Translation>
  );
};

CommonUnlockProBtn.propTypes = {
  me: PropTypes.object,
  className: PropTypes.string,
};
CommonUnlockProBtn.defaultProps = {
  me: null,
  className: '',
};

const mapStateToProps = state => ({
  me: state.usersReducer.me,
});

export default connect(
  mapStateToProps,
)(CommonUnlockProBtn);
